// eslint-disable-next-line import/no-cycle
import api from '@src/api';
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';

export const getAttendanceHistory = (payload: {
	year: number;
	month: number;
}): Observable<Action> => (
	api.get('attendance-history/', payload)
	// api.mock(100, [
	// 	{
	// 		date: '02/17',
	// 		shifts: [
	// 			{
	// 				is_holiday: false,
	// 				leave_applications: [],
	// 				make_up_punch_applications: [],
	// 				off_duty: {
	// 					id: 'string',
	// 					ip_or_location_name: '台北辦公室',
	// 					is_from_make_up: true,
	// 					make_up_application_id: '01J2ZKYV2J50SA7KQAVW0WD6FY',
	// 					off_duty_early: 30,
	// 					punch_at: '18:38',
	// 					punch_in_type: 'ip',
	// 				},
	// 				on_duty: {
	// 					id: 'string',
	// 					ip_or_location_name: '台北辦公室',
	// 					is_from_make_up: true,
	// 					make_up_application_id: '01J2ZKYV2J50SA7KQAVW0WD6FY',
	// 					on_duty_late: 30,
	// 					punch_at: '09:08',
	// 					punch_in_type: 'ip',
	// 				},
	// 				other_errors: null,
	// 				overtime_applications: [],
	// 				shift_id: '123123123',
	// 				shift_name: '測試班別',
	// 			},
	// 		],
	// 	},
	// ])
);

export const deletePunchInRecord = (payload: {
	id: number;
}): Observable<Action> => (
	api['delete'](`punch-in-records/${payload.id}`)
);

export interface IPunchInRecord {
	id: string;
	duty: boolean;
	punch_datetime: string;
	punch_in_type: string;
	ip_or_location_name: string;
	shift_id: string;
	shift_name: string;
	is_support_shift?: boolean;
	is_deferred: boolean;
	is_updated_from_back_desk: boolean;
	updated_at: string;
	updated_user_name: string;
	user_name: string;
	ip_address: string;
	ip_setting_id: string;
	latitude: string;
	longitude: string;
	location_id: string;
	qr_code_id: string;
	verify_code: string;
	auto_refresh_enabled: boolean;
	punch_in_type_desc: string;
	reason?: string;
	record_created_at?: string;
}

// BE 在「忘打卡申請單核可後自動建立的打卡紀錄」會把 reason 填成這個固定字串。
// log 頁地點欄位用這個值判斷是否要顯示「(忘打卡)」後綴，取代沒有的 is_from_make_up 旗標。
export const MAKE_UP_PUNCH_REASON = '由補打卡單建立';

export interface IGetPunchInRecordsResponse {
	daily_rollover_hour: number;
	daily_rollover_minute: number;
	is_rollover_previous_day: boolean;
	records: IPunchInRecord[];
}

export const getPunchInRecords = (payload: {
	user_id: string;
	query_date: string;
}): Observable<Action> => (
	api.get('punch-in-records/', payload)
);

export const putPunchInRecord = (payload: {
	id: string;
	duty: boolean;
	source_record_type: 'work' | 'rest';
	target_record_type: 'work' | 'rest';
	shift_id?: string;
}): Observable<Action> => {
	const { id, ...body } = payload;
	return api.put(`punch-in-records/${id}`, body);
};
